import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import UploadsPanel from './Uploads/UploadsPanel.jsx';
import {LeftDrawer} from './common/Drawers.jsx';

const UploadsSidebar = ({open, onClose, ...props}) => {
  return (
    <LeftDrawer
      open={open}
      onClose={onClose}
      PaperProps={{
        'data-testid': 'uploads-sidebar',
      }}
      {...props}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <UploadsPanel />
      </Box>
    </LeftDrawer>
  );
};

UploadsSidebar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default UploadsSidebar;
